import React from 'react';
import { array, bool, number, object, func } from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@fiverr-private/fit';
import { I18n } from '@fiverr-private/i18n-react';
import { setCheckoutDrawerOpen } from '../../../actions/checkoutPlan';
import { getPackageById, isRecurringGig } from '../../../reducers/packages';
import { selectPackage } from '../../../actions/packages';

import './style.scss';

const SelectButton = ({ currentPrice, onClick, hideButton = false }, { currencyConverter }) => {
    const formattedPrice = currencyConverter.convertWithFee(currentPrice);

    return (
        <>
            <div className="price-wrapper">
                <p className="tbody-5">{formattedPrice}</p>
            </div>
            {!hideButton && (
                <Button className="btn-select-package" color={Button.COLORS.BLACK} onClick={onClick}>
                    <I18n k={'gig_page_perseus.packages_table.select'} />
                </Button>
            )}
        </>
    );
};

SelectButton.propTypes = {
    currentPrice: number,
    onClick: func,
    hideButton: bool,
};

SelectButton.contextTypes = {
    currencyConverter: object,
    general: object,
};

SelectButton.defaultProps = {
    onClick: () => true,
};

const mapStateToProps = ({ packages }, ownProps) => {
    const packageData = getPackageById(packages, ownProps.id);

    return {
        currentPrice: packageData.currentPrice,
    };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
    onClick: () => {
        dispatch(selectPackage({ packageId: ownProps.id }));
        dispatch(setCheckoutDrawerOpen(true));
    },
});

const SelectButtonConnect = connect(mapStateToProps, mapDispatchToProps)(SelectButton);

const SelectPackage = ({ packageList, isRecurringGig, hideButtons = false }) => {
    const showTotalTitle = !isRecurringGig;

    return (
        <tr className="select-package">
            <td className="package-row-label">
                {showTotalTitle && <I18n k={'gig_page_perseus.packages_table.total'} />}
            </td>
            {packageList.map(({ id }) => (
                <td key={id}>
                    <SelectButtonConnect id={id} hideButton={hideButtons} />
                </td>
            ))}
        </tr>
    );
};

SelectPackage.propTypes = {
    packageList: array,
    isRecurringGig: bool,
    hideButtons: bool,
};

const mapSelectPackageStateToProps = (state) => {
    const { packages } = state;
    const { packageList } = packages;

    return {
        packageList,
        isRecurringGig: isRecurringGig(packages),
    };
};

export { SelectPackage, SelectButton };
export default connect(mapSelectPackageStateToProps)(SelectPackage);
